import axios from "axios";
import ENV from "../../../environment";

export default {
  state: {
    items: [],
    basket: {},
  },

  mutations: {
    addItems(state, items) {
      // Check if item with the same id is already in the list
      items.forEach((item) => {
        if (state.items.find((i) => i.id === item.id)) return;
        state.items.push(item);
      });
    },

    setBasketItem(state, { variationId, quantity }) {
      let basket = { ...state.basket };

      if (quantity <= 0) delete basket[variationId];
      else basket[variationId] = quantity;

      state.basket = basket;
    },
  },

  actions: {
    async fetchItems({ commit }, prefix) {
      let response = await axios.get(
        ENV.baseUrl + ENV.itemsByPrefixEndpoint + "?variantNumberPrefix=" + `${prefix}-` + "&pluginSetPreview=" + ENV.setPreview
      );
      if (!response.data) return;

      let items = response.data.items;

      // Filter out variations that are not active
      items = items.map((item) => {
        item.variations = item.variations.filter((variation) => variation.isActive);
        return item;
      });

      commit("addItems", items);

      return items;
    },

    async fetchItemsAllItemsForModule(context, { module, store }) {
      let prefixes = [];

      store.state[module].options.forEach((option) => {
        let subOptionPrefixes = option.options.map((subOption) => subOption.variantNumberPrefix);

        // Filter out nulls
        subOptionPrefixes = subOptionPrefixes.filter((subOptionPrefix) => subOptionPrefix);

        // Trim each value
        subOptionPrefixes = subOptionPrefixes.map((subPrefix) => subPrefix.trim());

        prefixes = [...prefixes, ...subOptionPrefixes];
      });

      // Remove duplicates
      prefixes = prefixes.filter((p, index) => prefixes.indexOf(p) === index);

      for (const prefix of prefixes) {
        store.dispatch("zusammenstellung/fetchItems", prefix);
      }
    },
  },
};
